import {useEffect} from 'react';

import captivePortalTemplateService from '../services/captivePortalTemplateService';
import log from '../services/logger/log';
import serviceWorkerService from '../services/serviceWorkerService';

const usePrepareTemplate = () => {
    const prepare = async () => {
        try {
            log.debug('usePrepareTemplate: Captive portal template preparation started');

            const swReg = await serviceWorkerService.registerServiceWorker();

            try {
                await serviceWorkerService.waitServiceWorkerActivated(swReg);
                log.debug('usePrepareTemplate: Service worker activated successfully');
            } catch (e) {
                log.warn('usePrepareTemplate: Failed to activate service worker', e.message);
            }

            await captivePortalTemplateService.prepareCaptivePortalTemplate();

            log.debug('usePrepareTemplate: Captive portal template preparation completed successfully');
        } catch (e) {
            log.warn('usePrepareTemplate: Captive portal template preparation failed', e.message);
        }
    };

    useEffect(() => {
        prepare();
    }, []);
};

export default usePrepareTemplate;
